import { css } from 'linaria';

export const wrapper = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-200);
`;
